import React, { useEffect, useRef } from "react";
import { useSlider } from "../../hooks/useSlider";
import styles from "./Slider.module.css";
import "nouislider/dist/nouislider.css";

export default function Slider({ name, maxLimit, minValue, maxValue, onSliderMinChanged, onSliderMaxChanged }) {
  const sliderRef = useRef(null);

  const handleSliderSet = (min, max) => {
    onSliderMinChanged?.(min);
    onSliderMaxChanged?.(max);
  };

  const { setSliderValues } = useSlider(sliderRef, maxLimit, handleSliderSet);

  useEffect(() => {
    setSliderValues(minValue, maxValue);
  }, [minValue, maxValue, setSliderValues]);

  return (
    <div className={styles.card}>
      <label className={styles.label}>{name}</label>
      <div className={styles.inputs}>
        <input
          type="number"
          value={minValue}
          onChange={(e) => {
            const val = parseFloat(e.target.value);
            if (!isNaN(val) && val <= maxValue) {
              onSliderMinChanged(val);
              setSliderValues(val, maxValue);
            }
          }}
          className={styles.input}
        />
        <input
          type="number"
          value={maxValue}
          onChange={(e) => {
            const val = parseFloat(e.target.value);
            if (!isNaN(val) && val >= minValue) {
              onSliderMaxChanged(val);
              setSliderValues(minValue, val);
            }
          }}
          className={styles.input}
        />
      </div>
      <div ref={sliderRef} className={styles.slider}></div>
    </div>
  );
}